<div id="page-title">
  <div id="page-content" class="inicio" id="transacoes">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="row" *ngIf="!error">
          <div class="container-datepicker col-xs-12">
              <app-datepicker (filter)="setFilterDate($event)"></app-datepicker>
          </div>
        </div>
        <div class="row" *ngIf="!error">
          <div class="col-sm-6">
            <div id="input-tag" class="input textarea caixa-pesquisa">
              <div>
                <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
              </div>
              <div class="filter-icon" ></div>
              <div [ngClass]="boxHidden ? 'box-hidden' : 'box-show'" class="box-filter"></div>
            </div>
          </div>
          <div class="col-sm-6">
          </div>
        </div>
        <div *ngIf="!loaded && !error" class="container-loading">
          <div class="btn btn-registrar loading"></div>
        </div>
        <div class="col-md-10 col-md-offset-1" *ngIf="error">
          <span class="error">Nenhuma informação disponível no momento</span>
          <span class="error">Tente novamente mais tarde</span>
        </div>
        <table [hidden]="!loaded" id="master-detail-table-nfse" style="width: 100%"></table>
      </div>
    </div>
  </div>
</div>

<app-modal-detail [showModal]="showModal" (eventClose)="eventClose()">
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12 col-sm-12" *ngIf="nfse && nfse.Cliente && nfse.Cliente.Nome">
        <div class="form-group">
          <label for="" class="control-label">Nome do Cliente</label>
          <p>
            {{nfse.Cliente.Nome}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6" *ngIf="nfse && nfse.NumeroNfs">
        <div class="form-group">
          <label for="" class="control-label">Número</label>
          <p>
            {{nfse.NumeroNfs}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" *ngIf="nfse && nfse.DataEmissao">
        <div class="form-group">
          <label for="" class="control-label">Data de Emissão</label>
          <p>
            {{nfse.DataEmissao}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6" *ngIf="nfse && nfse.CodigoTributacaoMunicipio">
        <div class="form-group">
          <label for="" class="control-label">Código de Tributação do Município</label>
          <p>
            {{nfse.CodigoTributacaoMunicipio}}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6" *ngIf="nfse && nfse.Serie">
        <div class="form-group">
          <label for="" class="control-label">Série</label>
          <p>
            {{nfse.Serie}}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12" *ngIf="nfse && nfse.ValorServico">
        <div class="form-group">
          <label for="" class="control-label">Valor do Serviço</label>
          <p>
            {{nfse.ValorServico}}
          </p>
        </div>
      </div>
    </div>
  </div>
</app-modal-detail>
